import { render, staticRenderFns } from "./PurchaseReport.vue?vue&type=template&id=71b20f31&scoped=true"
import script from "./PurchaseReport.vue?vue&type=script&lang=js"
export * from "./PurchaseReport.vue?vue&type=script&lang=js"
import style0 from "./PurchaseReport.vue?vue&type=style&index=0&id=71b20f31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b20f31",
  null
  
)

export default component.exports